/* La Revivance — page behaviours: painting reveal, dropdowns, filter/sort grids,
   policy contents, essay share. */
(function () {
  if (window.LRPages) return;

  /* ---------- painting reveal (eye button) ---------- */
  var immersivePage = null;
  var immersiveY = 0;

  function setImmersive(page, on) {
    var eye = page.querySelector('[data-lr-eye]');
    var art = page.querySelector('.lr-atmos__art');
    /* the whole painting starts just below the eye, which never moves */
    if (art) {
      if (on && eye) art.style.top = Math.max(Math.round(eye.getBoundingClientRect().bottom) + 14, 64) + 'px';
      if (!on) art.style.top = '';
    }
    page.classList.toggle('lr-is-immersive', on);
    document.documentElement.classList.toggle('lr-immersive-lock', on);
    if (eye) {
      eye.setAttribute('aria-pressed', on ? 'true' : 'false');
      eye.setAttribute('aria-label', on ? eye.dataset.labelOff : eye.dataset.labelOn);
    }
    immersivePage = on ? page : null;
    immersiveY = window.scrollY;
  }

  /* phones may still scroll a locked page: any real scroll returns to the page */
  window.addEventListener('scroll', function () {
    if (immersivePage && Math.abs(window.scrollY - immersiveY) > 80) setImmersive(immersivePage, false);
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var eye = e.target.closest('[data-lr-eye]');
    if (eye) {
      var page = eye.closest('[data-lr-page]') || document.body;
      setImmersive(page, !page.classList.contains('lr-is-immersive'));
      return;
    }

    /* tapping the painting (anywhere but the header) returns to the page */
    if (immersivePage && !e.target.closest('.section-header, .shopify-section-group-header-group')) {
      setImmersive(immersivePage, false);
      return;
    }

    var opt = e.target.closest('.lr-dd__opt');
    if (opt) {
      var dd = opt.closest('.lr-dd');
      dd.querySelectorAll('.lr-dd__opt').forEach(function (o) {
        o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
      });
      var label = dd.querySelector('[data-lr-dd-label]');
      if (label) label.textContent = opt.textContent.trim();
      dd.dataset.value = opt.dataset.value;
      dd.removeAttribute('open');
      dd.dispatchEvent(new CustomEvent('lr:change', { bubbles: true, detail: { value: opt.dataset.value } }));
      return;
    }

    document.querySelectorAll('.lr-dd[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.lr-dd[open]').forEach(function (d) { d.removeAttribute('open'); });
    if (immersivePage) setImmersive(immersivePage, false);
  });

  /* ---------- filter / sort / show-more grid ---------- */
  function LRGrid(root) {
    if (root.__lrGrid) return;
    root.__lrGrid = true;

    var list = root.querySelector('[data-lr-list]');
    if (!list) return;
    var items = Array.prototype.filter.call(list.children, function (n) { return n.hasAttribute('data-lr-item'); });
    items.forEach(function (it, i) { it.__i = i; });

    var promo = list.querySelector('[data-lr-promo]');
    var countEl = root.querySelector('[data-lr-count]');
    var emptyEl = root.querySelector('[data-lr-empty]');
    var moreEl = root.querySelector('[data-lr-more]');
    var limit = parseInt(root.dataset.lrLimit || '0', 10);
    var defaultSort = root.dataset.lrSort || 'default';
    var state = { filters: {}, sort: defaultSort, expanded: false };

    function isFiltered() {
      for (var k in state.filters) { if (state.filters[k] && state.filters[k] !== 'all') return true; }
      return false;
    }

    function matches(it) {
      for (var k in state.filters) {
        var v = state.filters[k];
        if (v && v !== 'all' && (it.dataset[k] || '') !== v) return false;
      }
      return true;
    }

    function cmp(a, b) {
      if (state.sort === 'default') return a.__i - b.__i;
      var p = state.sort.split(':');
      var key = p[0];
      var dir = p[1] === 'desc' ? -1 : 1;
      var va = a.dataset[key] || '';
      var vb = b.dataset[key] || '';
      if (va === '' && vb !== '') return 1;
      if (vb === '' && va !== '') return -1;
      var na = parseFloat(va), nb = parseFloat(vb);
      if (!isNaN(na) && !isNaN(nb) && na !== nb) return (na - nb) * dir;
      var c = va.localeCompare(vb, undefined, { sensitivity: 'base' }) * dir;
      return c || a.__i - b.__i;
    }

    function render() {
      var shown = items.filter(matches).sort(cmp);
      var plain = !isFiltered() && state.sort === defaultSort;
      var cap = (limit && plain && !state.expanded) ? limit : Infinity;

      items.forEach(function (it) { it.hidden = true; });
      shown.forEach(function (it, i) {
        list.appendChild(it);
        it.hidden = i >= cap;
      });

      if (promo) {
        var after = parseInt(promo.dataset.after || '6', 10);
        var anchor = shown[after - 1];
        if (plain && anchor && !anchor.hidden) {
          anchor.after(promo);
          promo.hidden = false;
        } else {
          promo.hidden = true;
        }
      }

      if (countEl) {
        var n = shown.length;
        var tpl = n === 1 ? root.dataset.labelOne : root.dataset.labelOther;
        if (tpl) countEl.textContent = tpl.replace('[count]', n);
      }
      if (emptyEl) emptyEl.hidden = shown.length > 0;
      if (moreEl) moreEl.hidden = !(cap < shown.length);
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-lr-filter-chip]');
      if (chip && root.contains(chip)) {
        var key = chip.dataset.lrFilterChip;
        root.querySelectorAll('[data-lr-filter-chip="' + key + '"]').forEach(function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        state.filters[key] = chip.dataset.value;
        render();
        return;
      }
      if (e.target.closest('[data-lr-more-btn]')) {
        state.expanded = true;
        render();
      }
    });

    root.addEventListener('lr:change', function (e) {
      var dd = e.target;
      if (dd.hasAttribute('data-lr-sort')) state.sort = e.detail.value;
      else if (dd.dataset.lrFilter) state.filters[dd.dataset.lrFilter] = e.detail.value;
      render();
    });

    render();
  }

  /* ---------- policies: real headings + "On this page" ---------- */
  /* names kept capitalised when an ALL-CAPS heading is turned into sentence case */
  var PROPER = ['Shopify', 'La Revivance', 'Revivance', 'Belgium', 'Belgique', 'Brussels', 'Bruxelles', 'Europe', 'European', 'Printful', 'Gelato', 'GDPR', 'RGPD', 'CCPA', 'EEA', 'EEE', 'UK', 'USA'];

  function sentenceCase(t) {
    if (t !== t.toUpperCase()) return t;
    var m = t.match(/^(SECTION|ARTICLE)\s+(\d+)\s*[-–—:]\s*(.*)$/i);
    var s = (m ? m[3] : t).toLowerCase();
    s = s.charAt(0).toUpperCase() + s.slice(1);
    PROPER.forEach(function (w) {
      s = s.replace(new RegExp('(^|[^\\p{L}])' + w.toLowerCase() + '(?=$|[^\\p{L}])', 'giu'), function (all, pre) { return pre + w; });
    });
    return m ? m[2] + '. ' + s : s;
  }

  function LRLegal(root) {
    if (root.__lrLegal) return;
    root.__lrLegal = true;
    var body = root.querySelector('[data-lr-legal-body]');
    if (!body) return;

    /* a paragraph that is only bold text is a heading in disguise */
    body.querySelectorAll('p').forEach(function (p) {
      var t = p.textContent.replace(/\s+/g, ' ').trim();
      if (!t) {
        if (!p.querySelector('img, iframe')) p.remove();
        return;
      }
      var strongs = p.querySelectorAll('strong, b');
      if (t.length > 90 || strongs.length !== 1) return;
      if (strongs[0].textContent.replace(/\s+/g, ' ').trim() !== t) return;
      var h = document.createElement('h2');
      h.className = 'lr-legal__h';
      h.textContent = t;
      p.replaceWith(h);
    });

    var toc = root.querySelector('[data-lr-toc]');
    var heads = body.querySelectorAll('h2, h3');
    heads.forEach(function (h, i) {
      h.classList.add('lr-legal__h');
      if (!h.id) h.id = 'lr-part-' + (i + 1);
    });
    if (!toc || heads.length < 8) return;

    var list = toc.querySelector('ol');
    heads.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = sentenceCase(h.textContent.trim());
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
    root.classList.add('lr-legal--toc');

    var wide = window.matchMedia('(min-width: 990px)');
    function syncOpen() { if (wide.matches) toc.open = true; }
    syncOpen();
    if (wide.addEventListener) wide.addEventListener('change', syncOpen);

    toc.addEventListener('click', function (e) {
      if (e.target.closest('a') && !wide.matches) toc.open = false;
    });

    if ('IntersectionObserver' in window) {
      var links = {};
      list.querySelectorAll('a').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          list.querySelectorAll('a.is-active').forEach(function (a) { a.classList.remove('is-active'); });
          if (links[en.target.id]) links[en.target.id].classList.add('is-active');
        });
      }, { rootMargin: '-90px 0px -70% 0px' });
      heads.forEach(function (h) { io.observe(h); });
    }
  }

  /* ---------- essays: share (native sheet, else copy the link) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lr-share]');
    if (!btn) return;
    var url = btn.dataset.url || window.location.href;
    if (navigator.share) {
      navigator.share({ title: btn.dataset.title || document.title, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        var label = btn.querySelector('[data-lr-share-label]');
        if (!label) return;
        var before = label.textContent;
        label.textContent = btn.dataset.copied || before;
        setTimeout(function () { label.textContent = before; }, 2200);
      });
    }
  });

  function init(scope) {
    (scope || document).querySelectorAll('[data-lr-grid]').forEach(LRGrid);
    (scope || document).querySelectorAll('[data-lr-legal]').forEach(LRLegal);
  }

  window.LRPages = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
